module.exports = __webpack_public_path__ + "home-2-new.png?1c8a57c018614fed14c8e6c2b3be6b92";